import React from 'react';
import {profieItems} from './utilities';
import {Link, useLocation} from 'react-router-dom';
import ExitUser from './exit';
import ProfileInfo from './Profile';

const ProfileContainer = () => {
  const location = useLocation();

  const isFarm = location.pathname.includes('farm');

  return (
    <div className="flex flex-col h-full gap-8 px-6 py-4">
      {!isFarm && <ProfileInfo />}
      {profieItems.map((item, index) => {
        return (
          <Link
            to={`/${isFarm ? 'farm' : 'wholesaler'}/${item.link}`}
            className="flex gap-4 text-medium text-[16px] items-center leading-[20px] text-black"
            key={index}
          >
            <span className={`${item.icon} text-primary`} />
            <p className="text-black">{item.title}</p>
          </Link>
        );
      })}
      {!isFarm && <ExitUser />}
    </div>
  );
};

export default ProfileContainer;
